import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { Link } from "./library/link";
import { slugify } from "../../custom_utils/helpers";
import { ResponsivePicture, singleCrop } from "../../../Shared/components/Image";
export const Book = (p)=>{
    let content = (p)=>/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "book__caption",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "book__header title--s",
                            children: "Boekentip"
                        }),
                        p.heading && p.heading == 'h4' ? /*#__PURE__*/ _jsx("h4", {
                            "data-anchor": slugify(p.title),
                            className: "book__title title--xs",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: p.title
                            })
                        }) : /*#__PURE__*/ _jsx("h3", {
                            "data-anchor": slugify(p.title),
                            className: "book__title title--xs",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: p.title
                            })
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "book__text",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: p.author
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "book__visual",
                    children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                        defaultImageUrl: p.imageUrlFallback,
                        cropsPerMedia: singleCrop(p.imageUrl),
                        alt: p.imageAlt,
                        imgClassName: "book__image"
                    })
                })
            ]
        });
    return /*#__PURE__*/ _jsx("article", {
        className: `book ${p.className || ''}`,
        children: p.url && p.url != "" ? /*#__PURE__*/ _jsx(Link, {
            url: p.url,
            className: "book__inner book__link",
            children: content(p)
        }) : /*#__PURE__*/ _jsx("div", {
            className: "book__inner",
            children: content(p)
        })
    });
};
export const BooksBlock = (p)=>/*#__PURE__*/ _jsxs("aside", {
        className: "books",
        children: [
            /*#__PURE__*/ _jsxs("header", {
                className: "books__header",
                children: [
                    p.title && /*#__PURE__*/ _jsx("h2", {
                        className: "books__title title--l",
                        children: p.title
                    }),
                    p.text && /*#__PURE__*/ _jsx("p", {
                        className: "books__intro",
                        children: p.text
                    })
                ]
            }),
            !p.books.isEmpty() && /*#__PURE__*/ _jsx("ul", {
                className: "books__list",
                children: p.books.map((book, k)=>/*#__PURE__*/ _jsx("li", {
                        className: "books__item",
                        children: /*#__PURE__*/ _jsx(Book, {
                            ...book
                        })
                    }, `book-${k}`))
            })
        ]
    });
